import { cn } from '@/utils'
export const WandFillIcon = ({
  className,
  color = '#1E1E1E',
}: {
  className?: string
  color?: string
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-800', className)}
    >
      <path
        d="M21.6388 3.6398L20.3588 2.3598C20.2463 2.24612 20.1124 2.15587 19.9648 2.09428C19.8171 2.03269 19.6588 2.00098 19.4988 2.00098C19.3389 2.00098 19.1805 2.03269 19.0329 2.09428C18.8853 2.15587 18.7513 2.24612 18.6388 2.3598L2.35882 18.6398C2.24514 18.7523 2.15489 18.8863 2.0933 19.0339C2.03171 19.1815 2 19.3399 2 19.4998C2 19.6598 2.03171 19.8181 2.0933 19.9657C2.15489 20.1133 2.24514 20.2473 2.35882 20.3598L3.63882 21.6398C3.75065 21.7547 3.88436 21.846 4.03207 21.9084C4.17978 21.9708 4.33849 22.0029 4.49882 22.0029C4.65916 22.0029 4.81787 21.9708 4.96558 21.9084C5.11329 21.846 5.247 21.7547 5.35882 21.6398L21.6388 5.3598C21.7537 5.24798 21.8451 5.11427 21.9074 4.96656C21.9698 4.81885 22.0019 4.66014 22.0019 4.4998C22.0019 4.33947 21.9698 4.18076 21.9074 4.03305C21.8451 3.88534 21.7537 3.75162 21.6388 3.6398Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
      <path
        d="M14 7L17 10"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
      <path
        d="M5 6V10"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
      <path
        d="M19 14V18"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
      <path
        d="M10 2V4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
      <path
        d="M7 8H3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
      <path
        d="M21 16H17"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
      <path
        d="M11 3H9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={color}
      />
    </svg>
  )
}
